import { Link } from "react-router-dom";

const friendLinks = [
  { label: "豆瓣电影", href: "https://movie.douban.com/" },
  { label: "时光网", href: "https://www.mtime.com/" },
  { label: "猫眼电影", href: "https://www.maoyan.com/" },
  { label: "IMDb", href: "https://www.imdb.com/" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className="ri-play-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white">91视频免费看</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              91视频免费看是面向广大影视爱好者的在线观看平台，汇聚海量高清电影与电视剧资源，
              覆盖动作、爱情、科幻、悬疑等多种类型，更新及时、操作简单，让你轻松找到想看的作品。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li><Link to="/" className="hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/movie" className="hover:text-accent-400 transition-colors">电影频道</Link></li>
              <li><Link to="/tv" className="hover:text-accent-400 transition-colors">电视剧频道</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">友情链接</h4>
            <ul className="space-y-2 text-sm text-background-300">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-400">
          <p>© {new Date().getFullYear()} 91视频免费看 · 本站所有资源均来自互联网公开信息，仅供学习交流，请于下载后 24 小时内删除。</p>
          <Link to="/about" className="hover:text-accent-400 transition-colors whitespace-nowrap">
            联系我们
          </Link>
        </div>
      </div>
    </footer>
  );
}